import {MenuOption} from '@lexical/react/LexicalTypeaheadMenuPlugin'
import {PopoverMenuItemType} from "../../../popover-menu/popover-menu/const"

export class InternalLinkOption extends MenuOption {

    id?             : ID
    type            : PopoverMenuItemType
    label           : string                        // label in menu
    icon?           : string                        // icon in menu
    iconComponent?  : any                           // iconComponent in menu, is used instead of icon property
    keywords        : Array<string>                 // extra searching keywords
    options?        : InternalLinkOption[]
    action?         : (queryString: string) => void // action on option select

    constructor(
        label   : string,
        config : {
            id?             : ID
            type?           : PopoverMenuItemType
            icon?           : string
            iconComponent?  : any
            keywords?       : Array<string>
            options?        : InternalLinkOption[]
            action?         : (queryString: string) => void
        },
    ) {
        super(label)
        this.id             = config.id
        this.type           = config.type || PopoverMenuItemType.ITEM
        this.label          = label
        this.keywords       = config.keywords || []
        this.icon           = config.icon
        this.iconComponent  = config.iconComponent
        this.options        = config.options
        this.action         = config.action ? config.action.bind(this) : undefined
    }
}
